import React from 'react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="hero"
      style={{
        position: 'relative',
        backgroundImage: "url('/images/background/great.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="hero-overlay"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.6)',
          zIndex: 1,
        }}
      ></div>
      <div
        className="hero-center-content"
        style={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <h1
          style={{
            fontWeight: 'bold',
            fontSize: '3rem',
            marginBottom: '1rem',
          }}
        >
          PT. TRITUNAS PUTRA NUSANTARA
        </h1>
        <p
          style={{
            fontSize: '1.5rem',
            marginBottom: '2rem',
            color: '#fff',
          }}
        >
          Menggerakkan Inovasi, Mewujudkan Pertumbuhan.
        </p>
        {/* ...existing code for buttons or additional content if needed... */}
      </div>
    </section>
  );
};

export default Hero;